import { render, staticRenderFns } from "./AboutCoverSection.vue?vue&type=template&id=484b193a&scoped=true&"
import script from "./AboutCoverSection.vue?vue&type=script&lang=js&"
export * from "./AboutCoverSection.vue?vue&type=script&lang=js&"
import style0 from "./AboutCoverSection.vue?vue&type=style&index=0&id=484b193a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484b193a",
  null
  
)

export default component.exports